import React from "react";

const Privacy = () => {
  return (
    <div className="privacy">
      {/* Privacy Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title animate-fade-up">Privacy Policy</h1>
          <p className="page-subtitle animate-fade-up">
            How we protect your information
          </p>
        </div>
        <div className="hero-overlay"></div>
        <div
          className="hero-image"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')",
          }}
        ></div>
      </section>

      <section className="privacy-content section-padding">
        <div className="container">
          <div className="privacy-section">
            <h2>Our Commitment to Your Privacy</h2>
            <p>
              At Laiger Clothing, we take your privacy seriously. This policy
              outlines how we collect, use, and protect your personal
              information when you visit our website or interact with us.
            </p>

            <div className="privacy-card">
              <h3>Information We Collect</h3>
              <p>We may collect the following types of information:</p>
              <ul>
                <li>
                  <strong>Contact Information:</strong> Name, email address,
                  phone number when you voluntarily provide it through our
                  contact forms.
                </li>
                <li>
                  <strong>Website Usage Data:</strong> Information about how you
                  interact with our website, including pages visited and time
                  spent, collected through cookies and analytics tools.
                </li>
                <li>
                  <strong>Communication Data:</strong> Records of any
                  correspondence between you and Laiger Clothing.
                </li>
              </ul>
            </div>

            <div className="privacy-card">
              <h3>How We Use Your Information</h3>
              <p>
                We use the information we collect for the following purposes:
              </p>
              <ul>
                <li>
                  To respond to your inquiries and provide customer support
                </li>
                <li>
                  To improve our website and services based on user interactions
                </li>
                <li>
                  To send occasional updates about our company and manufacturing
                  capabilities (only with your explicit consent)
                </li>
                <li>To comply with legal obligations and protect our rights</li>
              </ul>
            </div>

            <div className="privacy-card">
              <h3>Data Security</h3>
              <p>
                We implement appropriate technical and organizational measures
                to protect your personal information against unauthorized
                access, alteration, disclosure, or destruction. These measures
                include encryption, access controls, and secure server
                infrastructure.
              </p>
              <p>
                While we strive to protect your personal information, no method
                of transmission over the internet or electronic storage is 100%
                secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div className="privacy-card">
              <h3>Third-Party Services</h3>
              <p>
                We may use third-party services to help operate our website and
                business, such as website analytics providers. These third
                parties have access to your information only to perform specific
                tasks on our behalf and are obligated not to disclose or use it
                for any other purpose.
              </p>
            </div>

            <div className="privacy-card">
              <h3>Your Rights</h3>
              <p>You have the right to:</p>
              <ul>
                <li>Access the personal information we hold about you</li>
                <li>Request correction of any inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications at any time</li>
                <li>Withdraw consent for data processing where applicable</li>
              </ul>
              <p>
                To exercise any of these rights, please contact us using the
                information provided in our Contact Us section.
              </p>
            </div>

            <div className="privacy-card">
              <h3>Cookies</h3>
              <p>
                Our website uses cookies to enhance user experience. Cookies are
                small files stored on your device that help us analyze web
                traffic and remember your preferences. You can choose to accept
                or decline cookies through your browser settings.
              </p>
            </div>

            <div className="privacy-card">
              <h3>Changes to This Policy</h3>
              <p>
                We may update this privacy policy from time to time to reflect
                changes in our practices or legal requirements. We will notify
                you of any significant changes by posting the new policy on this
                page with an updated effective date.
              </p>
            </div>

            <div className="privacy-card">
              <h3>Contact Us</h3>
              <p>
                If you have any questions or concerns about this Privacy Policy
                or our data practices, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> privacy@laigerclothing.com
              </p>
              <p>
                <strong>Mail:</strong> Privacy Officer, Laiger Clothing, 123
                Fashion District, New York, NY 10001
              </p>
              <p>
                <strong>Effective Date:</strong> January 1, 2024
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
